// The mdi icon names are whole string literals on purpose: the build bundles
// exactly the icons it can find as literals (see CLAUDE.md "Icons").
const ICONS: Record<string, string> = {
  'application/pdf': 'mdi:file-pdf-box',
  'image/jpeg': 'mdi:file-image-outline',
  'image/png': 'mdi:file-image-outline',
  'application/msword': 'mdi:file-word-outline',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'mdi:file-word-outline',
  'application/vnd.ms-excel': 'mdi:file-excel-outline',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'mdi:file-excel-outline',
  'application/vnd.ms-powerpoint': 'mdi:file-powerpoint-outline',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'mdi:file-powerpoint-outline',
}

export const documentIcon = (contentType: string): string => ICONS[contentType] ?? 'mdi:file-document-outline'

// 1536 -> "1.5 kB". Decimal units, as file managers show them.
export function formatBytes(bytes: number, language = 'en'): string {
  if (bytes < 1000) return `${bytes} B`
  const units = ['kB', 'MB', 'GB']
  let value = bytes / 1000
  let unit = 0
  while (value >= 1000 && unit < units.length - 1) {
    value /= 1000
    unit++
  }
  const digits = value >= 100 ? 0 : 1
  return `${new Intl.NumberFormat(language, { maximumFractionDigits: digits, minimumFractionDigits: digits }).format(value)} ${units[unit]}`
}

// A year as the date range the API filters by, and back: the page offers a
// year, the API takes from and to.
export const yearRange = (year: number) => ({ from: `${year}-01-01`, to: `${year}-12-31` })
